import { render, staticRenderFns } from "./ProjectGroupDetailsProduction.vue?vue&type=template&id=581a2b16&"
import script from "./ProjectGroupDetailsProduction.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDetailsProduction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports